import React from 'react';
import { Tag } from 'antd';

/**
 * The wizard's status tags, lifted out of the editable preview step before it
 * was deleted so the running, problem and icon steps keep the same look.
 * [AVP-891]
 */

const TAG_BASE: React.CSSProperties = {
  margin: 0,
  borderRadius: 4,
  fontSize: 12,
  lineHeight: '20px',
};

export const OK_TAG: React.CSSProperties = {
  ...TAG_BASE,
  background: '#f6ffed',
  border: '1px solid #b7eb8f',
  color: '#52c41a',
};

export const ERROR_TAG: React.CSSProperties = {
  ...TAG_BASE,
  background: '#fdecec',
  border: '1px solid #f4b8b8',
  color: '#e13333',
};

export const GREY_TAG: React.CSSProperties = {
  ...TAG_BASE,
  background: '#fafafa',
  border: '1px solid #d9d9d9',
  color: '#8c909b',
};

export const MUTED_TEXT: React.CSSProperties = { fontSize: 13, color: '#8C909B' };

export const HEADER_CELL: React.CSSProperties = {
  padding: '17px 10px',
  background: '#fafafa',
  fontSize: 13,
  fontWeight: 600,
  color: 'rgba(0, 0, 0, 0.85)',
};

export const BODY_CELL: React.CSSProperties = {
  padding: '8px 10px',
  fontSize: 13,
  color: '#535559',
};

export type TProblemKind = 'invalid' | 'duplicate' | 'failed';

const LABELS: Record<TProblemKind, string> = {
  invalid: 'Invalid',
  duplicate: 'Duplicate',
  failed: 'Failed',
};

const STYLES: Record<TProblemKind, React.CSSProperties> = {
  invalid: ERROR_TAG,
  duplicate: GREY_TAG,
  failed: ERROR_TAG,
};

export const ProblemTag = ({ status }: { status: string }): JSX.Element => {
  const kind = (status in LABELS ? status : 'failed') as TProblemKind;
  return <Tag style={STYLES[kind]}>{LABELS[kind]}</Tag>;
};

ProblemTag.displayName = 'ProblemTag';

export const CountTag = (
  { count, label, tone }: { count: number; label: string; tone: React.CSSProperties },
): JSX.Element => (
  <Tag style={tone}>{`${count.toLocaleString()} ${label}`}</Tag>
);

CountTag.displayName = 'CountTag';
